export default "__VITE_ASSET__l7eO0TeO__"